export enum FilterType {
  IncludesString = "inc",
  ExcludesString = "exc",
  EqualsString = "eq",
  NotEquals = "neq",
  LessThan = "lt",
  GreaterThan = "gt",
  LessThanOrEqual = "lte",
  GreaterThanOrEqual = "gte",
  IsEmpty = "empty",
  IsNotEmpty = "nempty",
}
